module.exports = __webpack_public_path__ + "img/26d18cdeec0f4387afac43fdd8d17260-1024.aaf83843.png";